<template>
  <div class="col-sm-12">
    <div class="card">
      <div class="table-responsive signal-table">
        <table class="table table-hover">
          <thead>
            <tr>
              <th scope="col">Id</th>
              <th scope="col">Nombre Completo</th>
              <th scope="col">Usuario</th>
              <th scope="col" class="text-start">Rol</th>
              <th scope="col">Activo</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="user in paginatedItems" :key="user.id">
              <th scope="row">{{ user.id }}</th>
              <td>
                {{ user.name }} {{ user.first_last_name }}
                {{ user.second_last_name }}
              </td>
              <td>{{ user.username }}</td>
              <td class="align-items-center">
                <button class="btn btn-secondary" type="button" @click="showModal(user)">
                  <i class="fa fa-th-list"></i>
                </button>
              </td>
              <td>
                <div class="media-body icon-state switch-outline">
                  <label class="switch">
                    <input type="checkbox" @change="changeStatusUser(user.id)" :checked="user.has_access" /><span
                      class="switch-state bg-primary"></span>
                  </label>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="card-footer">
        <pagination class="card" style="padding-bottom: 10px" :totalItems="users.length" :itemsPerPage="itemsPerPage"
          @page-change="handlePageChange" />
      </div>
    </div>
  </div>

  <roleManagerModal ref="thisModal" :user="userChoose" :roles="roles" :userRoles="userRoles" @closeModal="closeModal" />
</template>

<script setup>
import roleManagerModal from "./elements/rolemanagermodal.vue";
import Pagination from "@/pages/components/Pagination.vue";
import axios from "@/includes/connection";
import { ref, onMounted, inject, computed } from "vue";

const swal = inject("$swal");

let users = ref([]);

const props = defineProps({ searchText: String });

onMounted(() => {
  loadUsers();
});

function loadUsers() {
  axios
    .get("/user")
    .then((response) => {
      if (response.data) {
        users.value = response.data;
      }
    })
    .catch(function (error) {
      console.log(data);
    });
}

function changeStatusUser(userid) {
  action_change_status_user(userid);
}

function action_change_status_user(userid) {
  axios
    .delete("/user/" + userid)
    .then((response) => {
      loadUsers();
    })
    .catch(function (error) {
      console.log("error: ", error);
      swal({
        text: "No se pudo cambiar el estado del usuario!",
      });
    });
}

let currentPage = ref(1);
let itemsPerPage = ref(10);

let paginatedItems = computed(() => {
  let filtered = users.value;
  if (props.searchText) {
    const q = props.searchText.toLowerCase();
    filtered = users.value.filter(
      u =>
        (u.name + " " + (u.first_last_name || "") + " " + (u.second_last_name || ""))
          .toLowerCase()
          .includes(q)
    );
  }
  const startIndex = (currentPage.value - 1) * itemsPerPage.value;
  const endIndex = startIndex + itemsPerPage.value;
  return filtered.slice(startIndex, endIndex);
});

function handlePageChange(page) {
  currentPage.value = page;
}

//----------- Info modal
const userChoose = ref({});
const roles = ref([]);
const userRoles = ref([]);

const listRoles = async () => {
  await axios
    .get("/rol/all")
    .then((response) => {
      roles.value = response.data;
    })
    .catch(function (error) {
      console.log(error);
    });
};

const listUserRoles = async () => {
  console.log("user choose: ", userChoose.value);
  await axios
    .get("/rol/user-roles/" + userChoose.value.id)
    .then((response) => {
      userRoles.value = response.data;
      console.log("user roles: ", userRoles.value);
    })
    .catch(function (error) {
      console.log(error);
    });
};

//----------- Modal Section
let modal = null;
import { Modal } from "bootstrap";
let thisModal = ref(null);

const showModal = async (item) => {
  console.log("show modal: ", item);
  userChoose.value = item;
  await listRoles();
  await listUserRoles();
  if (thisModal.value && thisModal.value.$el) {
    const modalElement = thisModal.value.$el;
    modal = new Modal(modalElement);
    modal.show();
  }
};

const closeModal = () => {
  if (modal) {
    modal.hide();
  }
};
</script>
